import PropTypes from "prop-types";
import React, { useContext } from "react";
import Header from "./header";
import Footer from "./footer";
import SiteMetaContext from "../../../contexts/SiteMetaContext";
import * as theme5Styles from "../scss/theme5.module.scss";
// import "../css/theme2.css";

function Layout({ children }) {
  const siteData = useContext(SiteMetaContext);

  const {
    remarso: {
      domainByURL: {
        website: {
          theme: colorTheme = "theme-default",
          setting: display_settings,
        },
      },
    },
  } = siteData;

  const { display_footer } = display_settings;

  let themeColor = `${theme5Styles.themeDefault}`;
  if (colorTheme == "theme-blue") {
    themeColor = `${theme5Styles.themeBlue}`;
  } else if (colorTheme == "theme-white") {
    themeColor = `${theme5Styles.themeWhite}`;
  } else if (colorTheme == "theme-orange") {
    themeColor = `${theme5Styles.themeOrange}`;
  } else if (colorTheme == "theme-red") {
    themeColor = `${theme5Styles.themeRed}`;
  }

  const wrapperClass = `${themeColor}`;

  return (
    <div className={wrapperClass}>
      <Header />
      <main className={`${theme5Styles.mainC}`}>{children}</main>
      {(() => {
        if (display_footer) {
          return <Footer />;
        }
      })()}
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
